import {
  Icon,
  Card,
  Input,
  Table,
  Button,
  message,
  Spin,
  Modal,
  Row,
  Col,
  notification,
  Tooltip,
  DatePicker,
  Select,
} from "antd";
import F from "../../../../Functions";
import { Link, withRouter } from "react-router-dom";
import { Translate, Translator } from "react-translated";
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import Pagination from "../../../../components/pagination";
import { AGENCY_MANAGER, COMPLETED_HISTORY, EA, EXPORT_DATA, EXTERNAL, EXTERNAL_RAC_COMPLETED_BY_CLIENT, get_label_from_value, INTELLIGENCE_LINK_COMPLETED, INTERNAL, LSP, SUPER_ADMIN } from "../../../../utils/Constants";
import {
  ASC,
  CARD_HISTORY_TYPE,
  DESC,
  SORT_ORDER_ASCEND,
  SORT_ORDER_DESCEND,
} from "../../../../utils/Constants";
import { COMBINED_COMPLETED_RAC_GRID, GET_AM_AO_AS_EXTERNAL_RAC_BFILE_GRID, GET_AM_ASSOCIATED_AGENCIES, GET_AM_DASH_COMPLETED_HISTORY_GRID, GET_AM_DASH_CUSTOMER_UPLOADED_HISTORY_GRID, GET_AM_DASH_NOT_INTERESTED_HISTORY_GRID, GET_AM_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID, GET_AO_DASH_COMPLETED_HISTORY_GRID, GET_AO_DASH_CUSTOMER_UPLOADED_HISTORY_GRID, GET_AO_DASH_NOT_INTERESTED_HISTORY_GRID, GET_AO_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID, GET_GLOBAL_DASH_COMPLETED_HISTORY_GRID, GET_GLOBAL_DASH_CUSTOMER_UPLOADED_HISTORY_GRID, GET_GLOBAL_DASH_EXTERNAL_RAC_BFILE_HISTORY_GRID, GET_GLOBAL_DASH_NOT_INTERESTED_HISTORY_GRID, GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID } from "../../../../utils/Api_enums";
import { debounce, set } from "lodash";
import { useBoundStore } from "../../../../store/useBoundStore";
import CustomAgGridTable from '../../../../Common-Table/CustomAgGridTable';
import CustomHeader from '../../../../CommonHeader/CustomHeader';
import { useRangePickerCloseButton } from '../../../../utils/rangePickerCloseButton';
import './BfileHistory.css'

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const ButtonGroup = Button.Group;
const dateFormat = "MM-DD-YYYY";
const GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY = "globalDashboardInitialAgencyDateRange";

/**
 * @param {user,call_type,title,selected_card_type} props
 * @returns
 */

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const { Option } = Select;

function BfileHistory(props) {
  const [open, setOpen] = useState(false);
  useRangePickerCloseButton(open, setOpen);
  const { user, history } = props;
  const START_DATE = "2010-01-01";
  const END_DATE = "2050-01-01";
  const defaultDate = F.getDefaultDateRange();


  const { AMDashboardFilter } = useBoundStore();

  const queryParams = new URLSearchParams(props.location.search);
  const title = decodeURIComponent(queryParams.get("title"));
  const call_type = decodeURIComponent(queryParams.get("call_type"));
  const selected_card_type = decodeURIComponent(queryParams.get("selected_card_type"));
  const hasAllBfiles = queryParams.has("all_bfiles");
  const hasDates = queryParams.has("dates");
  const hasCallType = queryParams.has("call_type");
  const isGlobalDashboard = queryParams.has("global_dashboard");

  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [sortConfig, setSortConfig] = useState({ field: "", direction: "" });

  const is_monthly = history.location.search.indexOf("monthly") >= 0 ||
    (hasCallType && !hasAllBfiles && !hasDates);


  let type_of_call = capitalizeFirstLetter(call_type);

  const [agency_id, setAgencyId] = useState(user.agency_id);

  const getInitialDates = (agencies) => {
    // const oldestDateRange = F.getOldestAgency()

    const queryParams = new URLSearchParams(props.location.search);
    const allBfiles = queryParams.has("all_bfiles");
    const hasDates = queryParams.has("dates");

    const filters = useBoundStore.getState().AMDashboardFilter;
    const globalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const userType = user.user_type;

    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

    if (isGlobalDashboard) {
      return { start_date: START_DATE, end_date: END_DATE };
    }

    if (userType === SUPER_ADMIN) {
      if (is_monthly) {
        return {
          start_date: startOfMonth,
          end_date: endOfMonth,
        };
      }

      const globalDates = globalDashboardFilter.datemodified || {};
      const initialAgencyDateRange = globalDashboardFilter.initialAgencyDateRange || {};
      const storedInitialAgencyDateRange = localStorage.getItem(GLOBAL_DASH_INITIAL_AGENCY_DATE_RANGE_KEY);

      if (hasDates) {
        if (initialAgencyDateRange.start_date && initialAgencyDateRange.end_date) {
          return {
            start_date: moment(initialAgencyDateRange.start_date).format("YYYY-MM-DD"),
            end_date: moment(initialAgencyDateRange.end_date).format("YYYY-MM-DD")
          };
        }

        if (storedInitialAgencyDateRange) {
          try {
            const parsedDateRange = JSON.parse(storedInitialAgencyDateRange);

            if (parsedDateRange.start_date && parsedDateRange.end_date) {
              return {
                start_date: moment(parsedDateRange.start_date).format("YYYY-MM-DD"),
                end_date: moment(parsedDateRange.end_date).format("YYYY-MM-DD")
              };
            }
          } catch (error) {
            console.error("Error parsing initial global dashboard agency date range:", error);
          }
        }

        const oldestAgency = F.getOldestAgency(agencies && agencies.length > 0 ? agencies : []);

        if (oldestAgency) {
          return {
            start_date: moment(oldestAgency.start_date).format("YYYY-MM-DD"),
            end_date: moment(oldestAgency.end_date || new Date()).format("YYYY-MM-DD")
          };
        }
      }

      if (globalDates.start_date && globalDates.end_date) {
        return {
          start_date: moment(globalDates.start_date).format("YYYY-MM-DD"),
          end_date: moment(globalDates.end_date).format("YYYY-MM-DD")
        };
      }

      return {
        start_date: START_DATE,
        end_date: END_DATE,
      };
    }


    if ([AGENCY_MANAGER, LSP, EA].includes(userType)) {
      const oldestAgency = F.getOldestAgency(agencies && agencies.length > 0 ? agencies : agencies);
      const dashboardDates = filters.datemodified || {};
      const hasDashboardDates = dashboardDates.start_date && dashboardDates.end_date;

      if (hasDashboardDates) {
        return {
          start_date: moment(dashboardDates.start_date).format("YYYY-MM-DD"),
          end_date: moment(dashboardDates.end_date).format("YYYY-MM-DD")
        };
      }

      if ((hasDates && (title === COMPLETED_HISTORY || title === EXTERNAL_RAC_COMPLETED_BY_CLIENT || title === INTELLIGENCE_LINK_COMPLETED))) {
        //added due to new date picker implementation
        if (userType == EA || userType == LSP) {
          return {
            start_date: defaultDate.start_date,
            end_date: defaultDate.end_date
          };
        } else if (user.user_type == AGENCY_MANAGER) {
          if (AMDashboardFilter.agency_id) {
            const savedDateObjAgencySelectionAM = JSON.parse(localStorage.getItem('dateObjAgencySelectionAM') || '{}');
            return {
              start_date: (savedDateObjAgencySelectionAM && savedDateObjAgencySelectionAM.start_date)
                || (AMDashboardFilter.datemodified &&
                  AMDashboardFilter.datemodified.start_date ?
                  AMDashboardFilter.datemodified.start_date : oldestAgency && oldestAgency.start_date),
              end_date: (savedDateObjAgencySelectionAM && savedDateObjAgencySelectionAM.end_date)
                || (AMDashboardFilter.datemodified &&
                  AMDashboardFilter.datemodified.end_date ?
                  AMDashboardFilter.datemodified.end_date : oldestAgency && oldestAgency.end_date)
            }

          } else {
            return {
              start_date: oldestAgency && oldestAgency.start_date,
              end_date: oldestAgency && oldestAgency.end_date
            }
          }

        }
        else {
          return {
            start_date: filters.datemodified.start_date,
            end_date: filters.datemodified.end_date
          }
        }

        //commented due to old date picker implementation
        // return { start_date: START_DATE, end_date: END_DATE };
      }


      if (filters && filters.isDateRangeClicked) {
        return {
          start_date: defaultDate.start_date,
          end_date: defaultDate.end_date
        };
      }

      return {
        start_date: oldestAgency && oldestAgency.start_date
          ? moment(oldestAgency.start_date).format("YYYY-MM-DD")
          : defaultDate.start_date,
        end_date: oldestAgency && oldestAgency.end_date
          ? moment(oldestAgency.end_date).format("YYYY-MM-DD")
          : defaultDate.end_date
      }

      // return {
      //   start_date: startOfMonth,
      //   end_date: endOfMonth,
      // };
    }


    return {
      start_date: is_monthly ? startOfMonth : START_DATE,
      end_date: is_monthly
        ? moment().add(1, "month").startOf("month").format("YYYY-MM-DD")
        : END_DATE,
    };
  };


  const { start_date: initialStartDate, end_date: initialEndDate } = getInitialDates();

  const [start_date, setStartDate] = useState(initialStartDate);
  const [end_date, setEndDate] = useState(initialEndDate);


  const [search, setSearch] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [lsp, setLsp] = useState([]);
  const user_t = localStorage.getItem("user_t");
  const initialGlobalDashboardFilter = useBoundStore.getState().GlobalDashboardFilter || {};
  const [selectedAgency, setSelectedAgency] = useState(
    user.user_type === SUPER_ADMIN
      ? ((initialGlobalDashboardFilter.selectedAgencies || []).length > 0 ? '' : (initialGlobalDashboardFilter.agency_id || ''))
      : AMDashboardFilter.agency_id
  );
  const [agencies, setAgencies] = useState([]);
  // const filter_lsp = localStorage.getItem("filter_lsp");
  const [bfiles, setBfiles] = useState({
    data: [],
    page: 1,
    total_pages: 0,
  });
  const type_of_call_selected = call_type;




  useEffect(() => {
    if (agency_id) return;
    let agencyId = ""
    axios.get("/api/user").then((res) => {
      if (res.data.user_agency_assoc && res.data.user_agency_assoc.length > 0) {
        agencyId = res.data.user_agency_assoc[0].agency_id || null;
      }
      setAgencyId(agencyId);
    })
  }, []);

  useEffect(() => {
    axios.get("/api/get_active_associations").then((res) => {
      let lsp = [];
      res.data.forEach((e) => {
        lsp.push({
          text: e.first_name + " " + e.last_name,
          value: e.first_name + " " + e.last_name,
        });
      });
      setLsp(lsp);
    });
  }, []);


  useEffect(() => {
    if (user.user_type == AGENCY_MANAGER) {
      fetchAssociatedAMAgencies();
    }
  }, [])


  const fetchAssociatedAMAgencies = async () => {
    try {
      const res = await axios.get(`${GET_AM_ASSOCIATED_AGENCIES}/${user.id}`);
      if (res.data && res.data.length > 0) {
        const { start_date, end_date } = getInitialDates(res.data);
        setStartDate(moment(start_date).format('YYYY-MM-DD'))
        setEndDate(moment(end_date).format('YYYY-MM-DD'))
        setAgencies(res.data);
      }
    } catch (error) {
      console.error("Error fetching associated agencies:", error);
    }
  };


  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi)

    // restore saved column state if present
    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }, []);


  const saveState = useCallback((params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }, []);


  useEffect(() => {
    if (agency_id || user.user_type == AGENCY_MANAGER || user.user_type === SUPER_ADMIN) {
      loadAppointmentLogs(1, search);
    }
  }, [agency_id,
    start_date, end_date,
    searchFilter]);


  const debouncedSearch = debounce((value) => {
    loadAppointmentLogs(1, value);
  }, 500);


  // useEffect(() => {
  //   if (search || search == '') {
  //     debouncedSearch(search);
  //   }
  //   return () => {
  //     debouncedSearch.cancel();
  //   };
  // }, [search]);


  const loadAppointmentLogs = async (
    page = 1,
    search = "",
    agency = selectedAgency,
    isExport = false,
    sortBy = sortConfig.field,
    sortDirection = sortConfig.direction
  ) => {
    setLoading(true);
    let from = start_date !== null ? `${start_date}` : null;
    let to = end_date !== null ? `${end_date}` : null;

    let direction = DESC;

    if (type_of_call_selected === "Review") {
      if ("ea_review_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_review_sorting_direction;
      }
    } else {
      if ("ea_virtual_sorting_direction" in window.localStorage) {
        direction = window.localStorage.ea_virtual_sorting_direction;
      }
    }

    getHistoryGrid({
      start_date: from, end_date: to, search: search,
      currentPage: page, agency_id: agency,
      isExport: isExport,
      sortBy,
      sortDirection
    });

  };


  const getGlobalDashboardAgencyIdsForHistory = (agencyId) => {
    const globalFilter = useBoundStore.getState().GlobalDashboardFilter || {};
    const selectedAgencies = globalFilter.selectedAgencies || [];
    const filteredAgencyIds = globalFilter.filteredAgencyIds || [];
    const hasCarrierOrStateFilter = (globalFilter.selectedCarriers || []).length > 0 ||
      (globalFilter.selectedAgencyState || []).length > 0;

    if (selectedAgencies.length > 0) {
      if (!agencyId || agencyId === globalFilter.agency_id) {
        return selectedAgencies;
      }
    }

    if (agencyId) {
      return [agencyId];
    }

    if (selectedAgencies.length > 0) {
      return selectedAgencies;
    }

    if (globalFilter.agency_id) {
      return [globalFilter.agency_id];
    }

    if (hasCarrierOrStateFilter) {
      return filteredAgencyIds.length > 0 ? filteredAgencyIds : [-1];
    }

    return [];
  };

  const fetchGlobalDashboardHistoryGrid = async ({
    apiUrl,
    start_date,
    end_date,
    search,
    currentPage,
    agency_id,
    isExport,
    sortBy,
    sortDirection
  }) => {
    const payload = {
      agency_ids: getGlobalDashboardAgencyIdsForHistory(agency_id),
      user_type: user.user_type,
      start_date,
      end_date,
      page: currentPage,
      ...(call_type && call_type != "null" ? { type_of_call: call_type } : {}),
      ...(search ? { search } : {}),
      ...(sortBy && sortDirection ? { sort: `${sortBy}:${sortDirection}` } : {}),
      ...(isExport ? { export: true } : {})
    };

    const response = await axios.post(
      apiUrl,
      payload,
      isExport ? { responseType: "blob" } : undefined
    );

    if (isExport) {
      if (response.data.type === "application/json") {
        message.error("No data found");
        return;
      }

      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;"
      });
      const fileName = `${title} Report_${moment().format("YYYY-MM-DD")}.csv`;
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = downloadUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      return;
    }

    let data = [];
    let page = 1;
    let total_pages = 0;

    if (response.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
      data = response.data.data;
      page = response.data.page;
      total_pages = response.data.total_pages;
    }

    setBfiles({
      data,
      page,
      total_pages,
    });
  };

  const getHistoryGrid = async ({ start_date = start_date, end_date = end_date, search, currentPage = 1, agency_id,
    isExport = false, sortBy, sortDirection
  }) => {
    const filter_lsp = localStorage.getItem("filter_lsp");
    let apiUrl;
    let userType = user.user_type === SUPER_ADMIN ? 'GLOBAL' : user.user_type === AGENCY_MANAGER ? 'AM' : 'AO';
    apiUrl = API_ENDPOINTS[selected_card_type] && API_ENDPOINTS[selected_card_type][userType];
    if (!apiUrl) {
      setBfiles({ data: [], page: 1, total_pages: 0 });
      setLoading(false);
      return;
    }
    try {
      if (user.user_type === SUPER_ADMIN && apiUrl !== COMBINED_COMPLETED_RAC_GRID) {
        await fetchGlobalDashboardHistoryGrid({
          apiUrl,
          start_date,
          end_date,
          search,
          currentPage,
          agency_id,
          isExport,
          sortBy,
          sortDirection
        });
        return;
      }

      const params = {
        start_date: start_date,
        end_date: end_date,
        page: currentPage,
        ...(user_t && user_t != 'all' ? { bfile_user_id: user_t } : {}),
        ...(call_type && call_type != "null" ? { type_of_call: call_type } : {}),
        ...(agency_id ? { agency_id: agency_id } : {}),
        ...(search ? { search: search } : {}),
        ...(sortBy && sortDirection ? { sort: `${sortBy}:${sortDirection}` } : {}),
        ...(filter_lsp ? { bfile_user_id: filter_lsp } : {}),
        ...(isExport ? { export: true } : {})
      };
      if (apiUrl === GET_AM_AO_AS_EXTERNAL_RAC_BFILE_GRID) {
        params.is_history = true;
      }
      if (apiUrl === COMBINED_COMPLETED_RAC_GRID) {
        const agencyIds = user.user_type === SUPER_ADMIN
          ? getGlobalDashboardAgencyIdsForHistory(agency_id)
          : [];
        params.is_history = true;
        params.per_page = 10;
        if (user.user_type === SUPER_ADMIN) {
          delete params.agency_id;
          if (agencyIds.length === 1) params.agency_id = agencyIds[0];
          if (agencyIds.length > 1) params.agency_ids = agencyIds.join(",");
        } else if (!params.agency_id && user.agency_id) {
          params.agency_id = user.agency_id;
        }
      }
      const queryString = new URLSearchParams(params).toString();

      const url = `${apiUrl}?${queryString}`;
      let response;

      if (isExport) {
        response = await axios.get(url, {
          responseType: "blob"
        });
      } else {
        response = await axios.get(url);
      }


      //  EXPORT FLOW
      if (isExport) {
        if (response.data.type === "application/json") {
          message.error("No data found");
          return;
        }

        const blob = new Blob([response.data], {
          type: "text/csv;charset=utf-8;"
        });

        const fileName = `${title} Report_${moment().format("YYYY-MM-DD")}.csv`;

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = downloadUrl;
        link.setAttribute("download", fileName);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(downloadUrl);

        return;
      }

      let data = [];
      let page = 1;
      let total_pages = 0;

      if (response.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
        data = response.data.data;
        page = response.data.page;
        total_pages = response.data.total_pages;
      }

      const bfiles = {
        data,
        page,
        total_pages,
      };

      setBfiles(bfiles);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  const selectAgency = (value) => {
    let startDate = start_date;
    let endDate = end_date;

    if (value && !isGlobalDashboard) {
      const selected = agencies.find(a => a.agency_id === value);

      if (selected) {
        startDate = moment(selected.start_date).format("YYYY-MM-DD");
        endDate = moment().format("YYYY-MM-DD");
      }
    }

    setStartDate(startDate);
    setEndDate(endDate);

    setLoading(true);
    setSelectedAgency(value);
    getHistoryGrid({ start_date: startDate, end_date: endDate, agency_id: value });
  };


  const API_ENDPOINTS = {
    [CARD_HISTORY_TYPE.UPLOAD]: {
      AM: GET_AM_DASH_CUSTOMER_UPLOADED_HISTORY_GRID,
      AO: GET_AO_DASH_CUSTOMER_UPLOADED_HISTORY_GRID,
      GLOBAL: GET_GLOBAL_DASH_CUSTOMER_UPLOADED_HISTORY_GRID,
    },
    [CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY]: {
      AM: GET_AM_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID,
      AO: GET_AO_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID,
      GLOBAL: GET_GLOBAL_DASH_SCHEDULED_ACTIVITIES_HISTORY_GRID,
    },
    [CARD_HISTORY_TYPE.NOT_INTERESTED]: {
      AM: GET_AM_DASH_NOT_INTERESTED_HISTORY_GRID,
      AO: GET_AO_DASH_NOT_INTERESTED_HISTORY_GRID,
      GLOBAL: GET_GLOBAL_DASH_NOT_INTERESTED_HISTORY_GRID,
    },
    [CARD_HISTORY_TYPE.COMPLETED]: {
      AM: GET_AM_DASH_COMPLETED_HISTORY_GRID,
      AO: GET_AO_DASH_COMPLETED_HISTORY_GRID,
      GLOBAL: GET_GLOBAL_DASH_COMPLETED_HISTORY_GRID,
    },
    [CARD_HISTORY_TYPE.EXTERNALLY_COMPLETED_BFILE]: {
      AM: GET_AM_AO_AS_EXTERNAL_RAC_BFILE_GRID,
      AO: GET_AM_AO_AS_EXTERNAL_RAC_BFILE_GRID,
      GLOBAL: GET_GLOBAL_DASH_EXTERNAL_RAC_BFILE_HISTORY_GRID,
    },
    [CARD_HISTORY_TYPE.INTELLIGENCE_LINK_COMPLETED]: {
      AM: COMBINED_COMPLETED_RAC_GRID,
      AO: COMBINED_COMPLETED_RAC_GRID,
      GLOBAL: COMBINED_COMPLETED_RAC_GRID,
    },
  };


  const handleExportExcel = () => {
    loadAppointmentLogs(1, search, agency_id, true)
  }


  const refreshStats = () => {
    if (isGlobalDashboard) {
      setSearch('');
      setSearchFilter("");
      setSelectedAgency('');
      setStartDate(START_DATE);
      setEndDate(END_DATE);

      localStorage.removeItem("agGridColumnState");
      if (columnApi) {
        columnApi.resetColumnState();
        columnApi.resetColumnGroupState();
      }
      setLoading(true);
      getHistoryGrid({
        start_date: START_DATE,
        end_date: END_DATE,
        search: '',
        currentPage: 1,
        agency_id: '',
      });
      return;
    }

    if (user.user_type === SUPER_ADMIN) {
      setSearch('');
      setSearchFilter("");
      setSelectedAgency('');

      const { start_date: refreshedStartDate, end_date: refreshedEndDate } = getInitialDates();
      const formattedStartDate = moment(refreshedStartDate).format("YYYY-MM-DD");
      const formattedEndDate = moment(refreshedEndDate).format("YYYY-MM-DD");

      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);

      localStorage.removeItem("agGridColumnState");
      if (columnApi) {
        columnApi.resetColumnState();
        columnApi.resetColumnGroupState();
      }
      setLoading(true);
      getHistoryGrid({
        start_date: formattedStartDate,
        end_date: formattedEndDate,
        search: '',
        currentPage: 1,
        agency_id: '',
      });
      return;
    }

    let amDashboardDateModified = useBoundStore.getState().AMDashboardFilter.datemodified;
    setSearch('');
    setSearchFilter("");
    const resetAgency = '';
    setSelectedAgency(resetAgency);
    const oldestAgency = F.getOldestAgency(agencies);
    let resetStartDate = amDashboardDateModified && amDashboardDateModified.start_date
      ? moment(amDashboardDateModified.start_date).format("YYYY-MM-DD")
      : defaultDate.start_date;
    let resetEndDate = amDashboardDateModified && amDashboardDateModified.end_date
      ? moment(amDashboardDateModified.end_date).format("YYYY-MM-DD")
      : defaultDate.end_date;

    //added due to new date picker implementation
    setStartDate(resetStartDate);
    setEndDate(resetEndDate);

    const hasDates = queryParams.has("dates");
    const filters = useBoundStore.getState().AMDashboardFilter;

    if ((hasDates && (title === COMPLETED_HISTORY || title === EXTERNAL_RAC_COMPLETED_BY_CLIENT || title === INTELLIGENCE_LINK_COMPLETED))) {
      //added due to new date picker implementation
      if (user.user_type == EA || user.user_type == LSP) {
        resetStartDate = moment(defaultDate.start_date).format("YYYY-MM-DD");
        resetEndDate = moment(defaultDate.end_date).format("YYYY-MM-DD");
        setStartDate(resetStartDate);
        setEndDate(resetEndDate);

      } else {
        const { start_date, end_date } = getInitialDates(agencies);
        resetStartDate = moment(start_date).format('YYYY-MM-DD');
        resetEndDate = moment(end_date).format('YYYY-MM-DD');
        setStartDate(resetStartDate)
        setEndDate(resetEndDate)
      }
    }





    // if (user.user_type == AGENCY_MANAGER) {
    //   if (oldestAgency) {
    //     setStartDate(moment(oldestAgency.start_date).format("YYYY-MM-DD"));
    //     setEndDate(moment().format("YYYY-MM-DD"));
    //   } else {
    //     setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
    //     setEndDate(moment().endOf("month").format("YYYY-MM-DD"));
    //   }
    // } else {
    //   setStartDate(defaultDate.start_date);
    //   setEndDate(defaultDate.end_date);
    // }


    //commented due to old date picker implementation
    // setStartDate(moment("2010-01-01").format("YYYY-MM-DD"));
    // setEndDate(moment("2050-01-01").format("YYYY-MM-DD"));

    localStorage.removeItem("agGridColumnState");
    if (columnApi) {
      columnApi.resetColumnState();
      columnApi.resetColumnGroupState();
    }
    getHistoryGrid({
      start_date: resetStartDate,
      end_date: resetEndDate,
      search: '',
      currentPage: 1,
      agency_id: resetAgency,
    });
  }

  const onChangeDate = (date, type) => {
    date = (date && moment(date).format("YYYY-MM-DD")) || null;
    if (type === "start_date") setStartDate(date);
    if (type === "end_date") setEndDate(date);
  };

  const handleRangeChange = (dates) => {
    const start = dates && dates[0]
      ? moment(dates[0]).format("YYYY-MM-DD")
      : null;

    const end = dates && dates[1]
      ? moment(dates[1]).format("YYYY-MM-DD")
      : null;

    setStartDate(start);
    setEndDate(end);

    // loadAppointmentLogs()
  };

  const CreateValueRenderer = (params) => {
    const { headers, data } = params;

    return (
      <div>
        {headers.map((header, index) => {
          let value = data[header];
          if (data) {
            if (value && (header == "updated_on" || header == 'last_updated')) {
              value = moment(data[header]).format("MM/DD/YYYY hh:mmA");
            } else if (header === 'who_reffered' || header === 'referred_by') {
              value = '-'
            } else if (header == "creator_user") {
              value = `${data.who_created}`
            }
          }
          else {
            value = data[header] || "-";
          }
          return (
            <div key={index}>
              <p style={{ marginTop: index > 0 ? "-25px" : "0px" }}>
                {value}
              </p>
            </div>

          );
        })}
      </div>
    )
  }

  const searchChange = (val) => {
    const searchPurify = F.removeSpecialCharactersFromString(val);
    const searchArr = searchPurify.trim().split(" ");
    let filters = "";

    if (searchPurify !== "") {
      const queries = [];
      searchArr.forEach((item) => {
        queries.push({
          name: "first_name",
          op: "like",
          val: encodeURIComponent("%" + item + "%"),
        });
        queries.push({
          name: "last_name",
          op: "like",
          val: encodeURIComponent("%" + item + "%"),
        });
      })
      filters = '{"or":' + JSON.stringify(queries) + "}";
    }
    setSearch(val);
    setSearchFilter(filters);
  };

  const handleSort = (field, requestedDirection) => {
    const nextDirection = requestedDirection || (
      sortConfig.field === field && sortConfig.direction === ASC ? DESC : ASC
    );

    setSortConfig({ field, direction: nextDirection });
    loadAppointmentLogs(1, search, selectedAgency, false, field, nextDirection);
  };

  let direction = DESC;

  if (type_of_call_selected === "Review") {
    if ("ea_review_sorting_direction" in window.localStorage) {
      direction = window.localStorage.ea_review_sorting_direction;
    }
  } else {
    if ("ea_virtual_sorting_direction" in window.localStorage) {
      direction = window.localStorage.ea_virtual_sorting_direction;
    }
  }

  // --- AG GRID COLUMN DEFINITIONS ---
  let agColumnDefs = [];
  if (selected_card_type === CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY) {
    agColumnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: 'Customer Name',
        field: 'customer_name',
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Customer Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'customer_name',
        }),
        filter: 'agTextColumnFilter',
        cellRendererFramework: (params) => params.value,
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Calendar Time',
        field: 'calendar_time',
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Calendar Time'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'calendar_time',
        }),
        filter: 'agTextColumnFilter',
        cellRendererFramework: (params) => <div>{params.value}</div>,
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Agency Staff',
        field: 'lsp',
        minWidth: 150,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Agency Staff'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'lsp',
          showPopOver: true,
          inputType: 'select',
        }),
        filter: 'agTextColumnFilter',
        cellRendererFramework: (params) => <div>{params.value}</div>,
      },
    ];
  } else {
    agColumnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: 'Name / Phone',
        field: 'name_phone',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Name', 'Phone'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'name_phone',
        }),
        filter: 'agTextColumnFilter',
        cellRendererFramework: (params) => params.value,
        autoHeaderHeight: true,
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Type of Call',
        field: 'type_of_call',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Type of Call'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'type_of_call',
        }),
        filter: 'agTextColumnFilter',
        cellRendererFramework: (params) => params.value,
        autoHeaderHeight: true,
      },
      {
        headerClass: 'custom-ag-header',
        headerName: 'Sub Type of Call',
        field: 'status',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Sub Type of Call'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'status',
        }),
        filter: 'agTextColumnFilter',
        cellRendererFramework: (params) => params.value,
        autoHeaderHeight: true,
      },
      {
        headerClass: 'custom-ag-header',
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ["Who Created", "Last Updated", "Who Referred"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "updated_on",
          sortOrder: sortConfig.field === "updated_on" ? sortConfig.direction : null,
          handleSort,
          showPopOver: false
        }),
        sortable: true,
        filter: true,
        autoHeight: true,
        cellRenderer: CreateValueRenderer,
        cellRendererParams: (params) => {
          const data = params.data || {};
          return {
            headers:
              ["creator_user", "updated_on", "who_reffered"]
          };
        },
        autoHeaderHeight: true
      },
    ];
    if (selected_card_type === CARD_HISTORY_TYPE.INTELLIGENCE_LINK_COMPLETED) {
      agColumnDefs.push({
        headerClass: 'custom-ag-header',
        headerName: 'Link Type',
        field: 'isExternal',
        minWidth: 130,
        flex: 1,
        sortable: false,
        filter: false,
        cellRendererFramework: (params) => {
          const normalizedValue = String(params.value).toLowerCase();
          const isExternal = params.value === true
            || params.value === 1
            || normalizedValue === "true"
            || normalizedValue === "1"
            || normalizedValue === EXTERNAL.toLowerCase();

          return <span>{isExternal ? EXTERNAL : INTERNAL}</span>;
        },
        autoHeaderHeight: true,
      });
    }
  }

  var data = [];
  if (bfiles.data && bfiles["data"].length !== 0) {
    if (selected_card_type === CARD_HISTORY_TYPE.SCHEDULE_ACTIVITY) {
      for (var i = 0; i < bfiles["data"].length; i++) {
        var bfile_data = bfiles["data"][i];
        // var calendar_time = moment(bfile_data.appointment_date).format("MM/DD/YYYY hh:mmA");
        let calendar_time;
        // = moment(bfile_data.appointment_date).format("MM/DD/YYYY hh:mmA")
        // if (user.user_type === AGENCY_MANAGER) {
        calendar_time =
          type_of_call_selected === "Review"
            ? moment(bfile_data.rs_appointment_date).format("MM/DD/YYYY hh:mmA")
            : moment(F.getVonBorderAppointmentDateFromBFile(bfile_data)).format(
              "MM/DD/YYYY hh:mmA"
            );
        // }
        data.push({
          id: i,
          customer_name: React.createElement(
            Link,
            {
              to: "/customer/" + bfile_data.id
            },
            `${bfile_data.first_name} ${bfile_data.last_name}`
          ),
          calendar_time: calendar_time || "-",
          lsp:
            user.user_type === AGENCY_MANAGER
              ? (
                (bfile_data && bfile_data.bfile && bfile_data.bfile.user && bfile_data.bfile.user.first_name || '-') +
                ' ' +
                (bfile_data && bfile_data.bfile && bfile_data.bfile.user && bfile_data.bfile.user.last_name || '-')
              )
              : (
                (bfile_data && bfile_data.bfile && bfile_data.bfile.user && bfile_data.bfile.user.first_name || '-') +
                ' ' +
                (bfile_data && bfile_data.bfile && bfile_data.bfile.user && bfile_data.bfile.user.last_name || '-')
              ),
        });
      }
    } else {
      for (var i = 0; i < bfiles["data"].length; i++) {
        var bfile_data = bfiles["data"][i];
        var bfile = bfile_data["bfile"] || bfile_data; // Handle case for AGENCY_MANAGER
        var ages = [];

        if (bfile && bfile.birthday) {
          ages.push(F.getAge(F.validDate(bfile.birthday, "/")));
        }
        if (bfile && bfile.spouse_birthday) {
          ages.push(F.getAge(F.validDate(bfile.spouse_birthday, "/")));
        }
        bfile.age_age = ages.length > 0 ? ages.join("/") : "-";

        var creator_name = "";
        if (bfile_data.creator_user) {
          creator_name = bfile_data.creator_user.first_name + " " + bfile_data.creator_user.last_name;
        } else if (bfile_data.user) {
          creator_name = bfile_data.user.first_name + " " + bfile_data.user.last_name;
        } else if (bfile_data.bfile && bfile_data.bfile.user) {
          creator_name = bfile_data.bfile.user.first_name + " " + bfile_data.bfile.user.last_name;
        } else if (bfile_data.bfile_user) {
          creator_name = bfile_data.bfile_user.first_name + " " + bfile_data.bfile_user.last_name;
        } else if (bfile_data.who_created) {
          creator_name = bfile_data.who_created;
        }



        bfile.priority = "Standard";
        if (bfile.need_attention == 1) bfile.priority = "Urgent";
        if (bfile.sp_500 == 1) bfile.priority = "S&P";
        if (bfile.vip == 1) bfile.priority = "VIP";

        var employment_status = F.bfile_employment_status(bfile);
        var status = F.bfile_status(bfile);
        var life_stage = F.bfile_life_stage(bfile).title;

        data.push({
          key: i,
          date: moment(bfile.created_on).format("MM/DD/YYYY hh:mmA"),
          expiration_date: moment(bfile.expiration_date).format("MM/DD/YYYY hh:mmA"),
          first_name: React.createElement(Link, { to: "/customer/" + bfile.id }, bfile.first_name),
          last_name: React.createElement(Link, { to: "/customer/" + bfile.id }, bfile.last_name),
          name_phone: React.createElement(
            "div",
            { style: { display: "flex", flexDirection: "column" } },
            React.createElement(
              Link,
              { to: "/customer/" + (selected_card_type == CARD_HISTORY_TYPE.COMPLETED ? bfile.bfile_id : bfile.id) },
              React.createElement(Icon, { type: "user", style: { marginRight: "5px", color: 'black' } }),
              bfile_data.first_name + " " + bfile_data.last_name
            ),
            React.createElement(
              "a",
              { href: "tel:" + F.phone_format(bfile_data.phone) },
              React.createElement(Icon, { type: "phone", style: { marginRight: "5px", color: 'black' } }),
              F.phone_format(bfile_data.phone)
            )
          ),
          agency_name: bfile_data.agency ? bfile_data.agency.name : "-",
          phone: React.createElement("a", { href: "tel:" + F.phone_format(bfile_data.phone) }, F.phone_format(bfile_data.phone)),
          email: bfile.email,
          appointment_date: moment(bfile.rs_appointment_date).format("MM/DD/YYYY hh:mm a"),
          ages: React.createElement(Translate, { text: employment_status || "" }),
          // ages: React.createElement("div", null,
          //   bfile.age_age,
          //   React.createElement("br"),
          //   React.createElement(Translate, { text: employment_status || "" })
          // ),
          type_of_call: F.getTypeOfCall(bfile_data, "-"),
          status: React.createElement("div", null,
            React.createElement("div", { style: { width: 150 } },
              React.createElement(Tooltip, { title: get_label_from_value(F.getSubTypeOfCall(bfile_data, "-"), "label", bfile_data.type_of_call) },
                React.createElement("div", { style: { textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" } },
                  get_label_from_value(F.getSubTypeOfCall(bfile_data, "-"), "label", bfile_data.type_of_call)
                )
              )
            )
          ),
          who_created: creator_name,
          updated_on: bfile_data.updated_on || bfile_data.last_updated,
          isExternal: typeof bfile_data.isExternal !== "undefined"
            ? bfile_data.isExternal
            : bfile.isExternal,
          // who_created: React.createElement("div", null,
          //   creator_name,
          //   React.createElement("br"),
          //   bfile_data.updated_on ? moment(bfile_data.updated_on).format("MM/DD/YYYY hh:mmA") : " ",
          //   React.createElement("br"),
          //   bfile.referred_by || "-"
          // ),
          life_stage: React.createElement(Translate, { text: life_stage || "" }),
          pc_cross_sell_opp: bfile.cross_sell_policies_uncovered
        });
      }
    }
  }



  const goback = () => {
    history.goBack();
  }

  return (
    <div className="bfile-history-container" style={{ backgroundColor: "white", padding: "20px" }}>
      <Row>
        <Col span={24}>
          <Button
            type="link"
            onClick={goback}
            style={{ marginBottom: 10, marginLeft: "-20px", color: "#164897" }}
          >
            <Icon type="arrow-left" />{" "}
            <Translate text={`Back`} />
          </Button>
        </Col>
      </Row>

      <div className="bfile-history-header" style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div className="bfile-history-title" style={{ width: "45%" }}>
          <div>
            <Icon type="folder" style={{ marginRight: 10, color: "#1890ff" }} />
            <b>
              <Translate text={title} />
            </b>
          </div>
          <Translator>
            {({ translate }) => (
              <Input
                className="bfile-history-search layoutsearch input-ellipse"
                suffix={
                  search ? (
                    <Icon
                      type="close"
                      onClick={() => {
                        setSearch("");
                        searchChange("");
                      }}
                      className="icon-style"
                      style={{
                        marginRight: '-15px'
                      }}
                    />
                  ) : (
                    <Icon
                      type="search"
                      className="icon-style"
                      style={{
                        marginRight: '-15px'
                      }}
                    />
                  )
                }
                value={search}
                placeholder={translate({ text: `Search File` })}
                style={{ width: "60%", marginTop: 10 }}
                onChange={(e) => setSearch(e.target.value)}
                onPressEnter={(e) => searchChange(e.target.value)}
              />
            )}
          </Translator>
        </div>
        <div className="bfile-history-filters" style={{ width: "55%", marginTop: "10px" }}>
          {
            user.user_type == AGENCY_MANAGER && (
              <div
                className="bfile-history-datepicker"
                style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
              >
                <div>
                  <Select
                    allowClear
                    showSearch
                    getPopupContainer={(trigger) => {
                      return trigger.parentElement;
                    }}
                    className='custom-select history-select'
                    style={{
                      fontSize: '12px',
                      backgroundColor: 'white',
                      borderRadius: '20px',
                      width: '180px',
                      marginTop: '28px',
                    }}
                    placeholder="Search By Agency"
                    optionFilterProp="children"
                    onChange={selectAgency}
                    filterOption={(input, option) => option.props.children.toLowerCase().includes(input.toLowerCase())}
                    value={selectedAgency}
                  >
                    <Option value="" style={{ fontSize: '12px' }}>
                      All Agencies
                    </Option>
                    {agencies.map((opt) => (
                      <Option key={opt.agency_id} value={opt.agency_id} style={{ fontSize: '12px' }}>
                        {opt.agency_name}
                      </Option>
                    ))}
                  </Select>
                </div>


                <div>
                  <div className="datepicker-label">Select Date Range</div>

                  <DatePicker.RangePicker
                    style={{ width: 300 }}
                    dropdownClassName="custom-range-picker" //for header
                    open={open}
                    // onOpenChange={(status) => setOpen(status)}
                    onOpenChange={(status) => {
                      if (!status) return;
                      setOpen(true);
                    }}
                    value={[
                      start_date ? moment(start_date) : null,
                      end_date ? moment(end_date) : null
                    ]}
                    format={dateFormat}
                    onChange={(dates) => {
                      if (dates && dates.length === 2) {
                        const start = dates[0].format("YYYY-MM-DD");
                        const end = dates[1].format("YYYY-MM-DD");
                        setStartDate(start);
                        setEndDate(end);
                        setOpen(true);
                      }
                    }}
                    renderExtraFooter={() => {
                      const start = start_date
                        ? moment(start_date)
                        : moment();

                      const end = end_date
                        ? moment(end_date)
                        : moment();

                      return (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between', gap: 20
                        }}>

                          {/* START CONTROLS */}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                            <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={start.month()}
                                style={{ width: 100 }}
                                // className="dateRangedropDown custom-select"
                                onChange={(month) => {
                                  const newDate = start.clone().month(month);
                                  setStartDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getMonthNames().map((m, i) => (
                                  <Option key={i} value={i}>{m}</Option>
                                ))}
                              </Select>

                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={start.year()}
                                // className="dateRangedropDown custom-select"
                                style={{ width: 80 }}
                                onChange={(year) => {
                                  const newDate = start.clone().year(year);
                                  setStartDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getYears().map((y) => (
                                  <Option key={y} value={y}>{y}</Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          {/* END CONTROLS */}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                            <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={end.month()}
                                style={{ width: 100 }}
                                // className="dateRangedropDown custom-select"
                                onChange={(month) => {
                                  const newDate = end.clone().month(month);
                                  setEndDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getMomentMonths().map((m, i) => (
                                  <Option key={i} value={i}>{m}</Option>
                                ))}
                              </Select>

                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={end.year()}
                                style={{ width: 80 }}
                                // className="dateRangedropDown custom-select"
                                onChange={(year) => {
                                  const newDate = end.clone().year(year);
                                  setEndDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getYears().map((y) => (
                                  <Option key={y} value={y}>{y}</Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          {/* TODAY BUTTON */}
                          <div
                            style={{
                              alignSelf: 'center', cursor: 'pointer',
                              color: '#1890ff',
                              marginTop: '10px'
                            }}
                            onClick={() => {
                              const today = moment().format("YYYY-MM-DD");
                              setStartDate(today);
                              setEndDate(today);
                            }}
                          >
                            Today
                          </div>

                          {/* VIEW BUTTON */}

                          <div
                            style={{
                              alignSelf: 'center'
                            }}>
                            <Button type="primary"
                              className="borderRadius-28 bg-164897"
                              style={{ marginTop: '15px' }}
                              onClick={() => {

                                setStartDate(start);
                                setEndDate(end);

                                handleRangeChange([start, end]);
                                setOpen(false);
                              }}
                            >
                              <Translate text={"Apply"}></Translate>
                            </Button>
                          </div>
                        </div>
                      );
                    }}
                  />
                </div>

                {/* <div>
                  <div className="datepicker-label">Start Date</div>
                  <DatePicker
                    value={(start_date && moment(start_date)) || null}
                    format={dateFormat}
                    onChange={(e) => {
                      onChangeDate(e, "start_date");
                    }}
                  />
                </div>
                <div>
                  <div className="datepicker-label">End Date</div>
                  <DatePicker
                    value={(end_date && moment(end_date)) || null}
                    format={dateFormat}
                    onChange={(e) => {
                      onChangeDate(e, "end_date");
                    }}
                  />
                </div> */}
                <div>
                  <Button
                    type='primary'
                    className='refresh-con'
                    onClick={() => refreshStats()}
                  >
                    <Icon type="reload" />
                  </Button>
                </div>
              </div>
            )}

          {
            user.user_type != AGENCY_MANAGER && (
              <div
                className="bfile-history-datepicker"
                style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
              >
                <div>
                  <div className="datepicker-label">Select Date Range</div>

                  <DatePicker.RangePicker
                    style={{ width: 300 }}
                    dropdownClassName="custom-range-picker" //for header
                    open={open}
                    // onOpenChange={(status) => setOpen(status)}
                    onOpenChange={(status) => {
                      if (!status) return;
                      setOpen(true);
                    }}
                    value={[
                      start_date ? moment(start_date) : null,
                      end_date ? moment(end_date) : null
                    ]}
                    format={dateFormat}
                    onChange={(dates) => {
                      if (dates && dates.length === 2) {
                        const start = dates[0].format("YYYY-MM-DD");
                        const end = dates[1].format("YYYY-MM-DD");
                        setStartDate(start);
                        setEndDate(end);
                        setOpen(true);
                      }
                    }}
                    renderExtraFooter={() => {
                      const start = start_date
                        ? moment(start_date)
                        : moment();

                      const end = end_date
                        ? moment(end_date)
                        : moment();

                      return (
                        <div style={{
                          display: 'flex',
                          justifyContent: 'space-between', gap: 20
                        }}>

                          {/* START CONTROLS */}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                            <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={start.month()}
                                style={{ width: 100 }}
                                // className="dateRangedropDown custom-select"
                                onChange={(month) => {
                                  const newDate = start.clone().month(month);
                                  setStartDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getMonthNames().map((m, i) => (
                                  <Option key={i} value={i}>{m}</Option>
                                ))}
                              </Select>

                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={start.year()}
                                // className="dateRangedropDown custom-select"
                                style={{ width: 80 }}
                                onChange={(year) => {
                                  const newDate = start.clone().year(year);
                                  setStartDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getYears().map((y) => (
                                  <Option key={y} value={y}>{y}</Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          {/* END CONTROLS */}
                          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                            <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                            <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={end.month()}
                                style={{ width: 100 }}
                                // className="dateRangedropDown custom-select"
                                onChange={(month) => {
                                  const newDate = end.clone().month(month);
                                  setEndDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getMomentMonths().map((m, i) => (
                                  <Option key={i} value={i}>{m}</Option>
                                ))}
                              </Select>

                              <Select
                                showSearch
                                getPopupContainer={(trigger) => {
                                  return trigger.parentElement;
                                }}
                                value={end.year()}
                                style={{ width: 80 }}
                                // className="dateRangedropDown custom-select"
                                onChange={(year) => {
                                  const newDate = end.clone().year(year);
                                  setEndDate(newDate);
                                }}
                                filterOption={(input, option) =>
                                  option.props.children &&
                                  option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                                }
                              >
                                {F.getYears().map((y) => (
                                  <Option key={y} value={y}>{y}</Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          {/* TODAY BUTTON */}
                          <div
                            style={{
                              alignSelf: 'center', cursor: 'pointer',
                              color: '#1890ff',
                              marginTop: '10px'
                            }}
                            onClick={() => {
                              const today = moment().format("YYYY-MM-DD");
                              setStartDate(today);
                              setEndDate(today);
                            }}
                          >
                            Today
                          </div>

                          {/* VIEW BUTTON */}

                          <div
                            style={{
                              alignSelf: 'center'
                            }}>
                            <Button type="primary"
                              className="borderRadius-28 bg-164897"
                              style={{ marginTop: '15px' }}
                              onClick={() => {

                                setStartDate(start);
                                setEndDate(end);

                                handleRangeChange([start, end]);
                                setOpen(false);
                              }}
                            >
                              <Translate text={"Apply"}></Translate>
                            </Button>
                          </div>
                        </div>
                      );
                    }}
                  />


                </div>

                <div>
                  {
                    user.user_type !== SUPER_ADMIN && (
                      <Button
                        type='primary'
                        className='borderRadius-28 bg-164897'
                        onClick={() => handleExportExcel()}
                      >
                        <Icon type="upload" style={{ marginRight: '10px' }} />
                        <Translate text={EXPORT_DATA} />
                      </Button>
                    )
                  }
                </div>

                <div>
                  <Button
                    type='primary'
                    className='refresh-con'
                    onClick={() => refreshStats()}
                  >
                    <Icon type="reload" />
                  </Button>
                </div>
              </div>


              // <div
              //   className="bfile-history-datepicker"
              //   style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
              // >
              //   <div>
              //     <div className="datepicker-label">Start Date</div>
              //     <DatePicker
              //       value={(start_date && moment(start_date)) || null}
              //       format={dateFormat}
              //       onChange={(e) => {
              //         onChangeDate(e, "start_date");
              //       }}
              //     />
              //   </div>
              //   <div>
              //     <div className="datepicker-label">End Date</div>
              //     <DatePicker
              //       value={(end_date && moment(end_date)) || null}
              //       format={dateFormat}
              //       onChange={(e) => {
              //         onChangeDate(e, "end_date");
              //       }}
              //     />
              //   </div>
              //   <div>
              //     <Button
              //       type='primary'
              //       className='borderRadius-28 bg-164897'
              //       onClick={() => handleExportExcel()}
              //     >
              //       <Icon type="upload" style={{ marginRight: '10px' }} />
              //       <Translate text={EXPORT_DATA} />
              //     </Button>
              //   </div>

              //   <div>
              //     <Button
              //       type='primary'
              //       className='refresh-con'
              //       onClick={() => refreshStats()}
              //     >
              //       <Icon type="reload" />
              //     </Button>
              //   </div>
              // </div>
            )
          }
        </div>
      </div>

      <Row>
        <Spin indicator={antIcon} spinning={loading}>
          <div className="bfile-history-table-container" style={{ marginBottom: 20 }}>
            <Card bordered={false} className="statsDetails have_extra">
              <div className="mb-10"></div>
              <CustomAgGridTable
                rowDatas={data}
                onGridReady={onGridReady}
                onColumnMoved={saveState}
                onSortChanged={saveState}
                onFilterChanged={saveState}
                columnDefss={agColumnDefs}
              />
              <div className="bfile-history-pagination" style={{ float: "right" }}>
                <Pagination
                  current_page={bfiles.page}
                  total_pages={bfiles.total_pages}
                  onClick={(page) => {
                    loadAppointmentLogs(page);
                  }}
                />
              </div>
            </Card>
          </div>
        </Spin>
      </Row>
    </div>
  );
}

export default withRouter(BfileHistory);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/EA_And_LSP/BfileHistory.js